<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl4 lg4 xs6>
                       <v-text-field v-model="filters.vesNo" :label="filtersLabel.vesNo" :error-messages="errors.collect('vesNo')" data-vv-name="vesNo" :data-vv-as="filtersLabel.vesNo"></v-text-field>
                    </v-flex>
                    <v-flex xl4 lg4 xs6>
                      <v-text-field v-model="filters.vesName" :label="filtersLabel.vesName" :error-messages="errors.collect('vesName')" data-vv-name="vesName" :data-vv-as="filtersLabel.vesName"></v-text-field>
                    </v-flex>
                    <v-flex xl4 lg4 xs6>
                      <v-text-field v-model="filters.vesDesc" :label="filtersLabel.vesDesc" :error-messages="errors.collect('vesDesc')" data-vv-name="vesDesc" :data-vv-as="filtersLabel.vesDesc"></v-text-field>
                    </v-flex>
                    <v-flex xl4 lg4 xs6>
                      <v-text-field v-model="filters.vesOwn" :label="filtersLabel.vesOwn" :error-messages="errors.collect('vesOwn')" data-vv-name="vesOwn" :data-vv-as="filtersLabel.vesOwn"></v-text-field>
                    </v-flex>
                    <v-flex xl4 lg4 xs6>
                      <v-text-field v-model="filters.vesAgt" :label="filtersLabel.vesAgt" :error-messages="errors.collect('vesAgt')" data-vv-name="vesAgt" :data-vv-as="filtersLabel.vesAgt"></v-text-field>
                    </v-flex>
                    <v-flex xl4 lg4 xs6>
                      <v-text-field v-model="filters.yrBuilt" :label="filtersLabel.yrBuilt" :error-messages="errors.collect('yrBuilt')" data-vv-name="yrBuilt" :data-vv-as="filtersLabel.yrBuilt" v-validate="'integer|max:4'"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <transition name="slide-x-transition" mode="out-in">
                    <v-layout row wrap v-if="showDetailFilters">
                      <v-flex xl4 lg4 xs6>
                        <v-autocomplete :items="vesFlagList" v-model="filters.vesFlagDesc" :label="filtersLabel.vesFlagDesc" item-text="label" item-value="value" data-vv-name="vesFlagDesc" :data-vv-as="filtersLabel.vesFlagDesc" :error-messages="errors.collect('vesFlagDesc')" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-autocomplete :items="vesClsList" v-model="filters.vesClsDesc" :label="filtersLabel.vesClsDesc" item-text="label" item-value="value" data-vv-name="vesClsDesc" :data-vv-as="filtersLabel.vesClsDesc" :error-messages="errors.collect('vesClsDesc')" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-autocomplete :items="vesConstnList" v-model="filters.vesConstnDesc" :label="filtersLabel.vesConstnDesc" item-text="label" item-value="value" data-vv-name="vesConstnDesc" :data-vv-as="filtersLabel.vesConstnDesc" :error-messages="errors.collect('vesConstnDesc')" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-autocomplete :items="vesEngMakeList" v-model="filters.vesEngMakeDesc" :label="filtersLabel.vesEngMakeDesc" item-text="label" item-value="value" data-vv-name="vesEngMakeDesc" :data-vv-as="filtersLabel.vesEngMakeDesc" :error-messages="errors.collect('vesEngMakeDesc')" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-autocomplete :items="vesEngModList" v-model="filters.vesEngModDesc" :label="filtersLabel.vesEngModDesc" item-text="label" item-value="value" data-vv-name="vesEngModDesc" :data-vv-as="filtersLabel.vesEngModDesc" :error-messages="errors.collect('vesEngModDesc')" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-autocomplete :items="vesTypeList" v-model="filters.vesTypeDesc" :label="filtersLabel.vesTypeDesc" item-text="label" item-value="value" data-vv-name="vesTypeDesc" :data-vv-as="filtersLabel.vesTypeDesc" :error-messages="errors.collect('vesTypeDesc')" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-text-field v-model="filters.grt" :label="filtersLabel.grt" :error-messages="errors.collect('grt')" data-vv-name="grt" :data-vv-as="filtersLabel.grt" v-validate="'numeric|max:10'"></v-text-field>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-text-field v-model="filters.nrt" :label="filtersLabel.nrt" :error-messages="errors.collect('nrt')" data-vv-name="nrt" :data-vv-as="filtersLabel.nrt" v-validate="'numeric|max:10'"></v-text-field>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-text-field v-model="filters.dwt" :label="filtersLabel.dwt" :error-messages="errors.collect('dwt')" data-vv-name="dwt" :data-vv-as="filtersLabel.dwt" v-validate="'numeric|max:10'"></v-text-field>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-text-field v-model="filters.imoRefNo" :label="filtersLabel.imoRefNo" :error-messages="errors.collect('imoRefNo')" data-vv-name="imoRefNo" :data-vv-as="filtersLabel.imoRefNo"></v-text-field>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-text-field v-model="filters.licenceNo" :label="filtersLabel.licenceNo" :error-messages="errors.collect('licenceNo')" data-vv-name="licenceNo" :data-vv-as="filtersLabel.licenceNo"></v-text-field>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-text-field v-model="filters.vesEngNo" :label="filtersLabel.vesEngNo" :error-messages="errors.collect('vesEngNo')" data-vv-name="vesEngNo" :data-vv-as="filtersLabel.vesEngNo"></v-text-field>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-text-field v-model="filters.mds" :label="filtersLabel.mds" :error-messages="errors.collect('mds')" data-vv-name="mds" :data-vv-as="filtersLabel.mds" v-validate="'integer|max:10'"></v-text-field>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-text-field v-model="filters.breath" :label="filtersLabel.breath" :error-messages="errors.collect('breath')" data-vv-name="breath" :data-vv-as="filtersLabel.breath"></v-text-field>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-text-field v-model="filters.length" :label="filtersLabel.length" :error-messages="errors.collect('length')" data-vv-name="length" :data-vv-as="filtersLabel.length"></v-text-field>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-text-field v-model="filters.depth" :label="filtersLabel.depth" :error-messages="errors.collect('depth')" data-vv-name="depth" :data-vv-as="filtersLabel.depth"></v-text-field>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-text-field v-model="filters.hp" :label="filtersLabel.hp" :error-messages="errors.collect('hp')" data-vv-name="hp" :data-vv-as="filtersLabel.hp" v-validate="'integer|max:10'"></v-text-field>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-text-field v-model="filters.totCrew" :label="filtersLabel.totCrew" :error-messages="errors.collect('totCrew')" data-vv-name="totCrew" :data-vv-as="filtersLabel.totCrew" v-validate="'integer|max:10'"></v-text-field>
                      </v-flex>
                      <v-flex xl4 lg4 xs6>
                        <v-text-field v-model="filters.manufName" :label="filtersLabel.manufName" :error-messages="errors.collect('manufName')" data-vv-name="manufName" :data-vv-as="filtersLabel.manufName"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </transition>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn flat="flat" @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-flex xs12>
      <v-layout row>
        <v-spacer></v-spacer>
        <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
          <v-btn color="secondary" class="white--text" slot="activator">
            <span>Columns</span>
            <v-icon right dark>mdi-table-column-plus-after</v-icon>
          </v-btn>
          <v-card>
            <v-card-text>
              <template v-if="columns.length > 0">
                <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
              </template>
              <template v-else>
                No column found
              </template>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-layout>
    </v-flex>
    <v-flex xs12 class="mt-2">
      <v-data-table :headers="listHeaders" :items="items" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" class="elevation-1" :rows-per-page-items="itemsPerPage" :no-data-text="noDataText">
        <template slot="items" slot-scope="props">
          <td v-for="column in selectedColumns" :key="column">
            {{props.item[column]}}
          </td>
          <td class="text-xs-right">
            <table-action :rowData="props" :review="checkAccess(['vesselReview'])" @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()">
        New Vessel
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-flex>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Vessel? ({{deleteVessel}})
    </confirm>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { listVesMixin } from '../listVesMixin.js'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  data() {
    return {
      columns: [
        { text: 'Vessel No', align: 'left', value: 'vesNo' },
        { text: 'Vessel Name', value: 'vesName' },
        { text: 'Vessel Description', value: 'vesDesc' },
        { text: 'Vessel Owner', value: 'vesOwn' },
        { text: 'Vessel Agent', value: 'vesAgt' },
        { text: 'Year Built', value: 'yrBuilt' },
        { text: 'Gross Register Tonnage', value: 'grt' },
        { text: 'Nett Register Tonnage', value: 'nrt' },
        { text: 'Dead Weight Tonnage', value: 'dwt' },
        { text: 'IMO Reference No', value: 'imoRefNo' },
        { text: 'Licence No', value: 'licenceNo' },
        { text: 'Vessel Engine No', value: 'vesEngNo' },
        { text: 'Min. Discernable Signal', value: 'mds' },
        { text: 'Length', value: 'length' },
        { text: 'Breath', value: 'breath' },
        { text: 'Depth', value: 'depth' },
        { text: 'Horse Power', value: 'hp' },
        { text: 'Total Crew', value: 'totCrew' },
        { text: 'Manufacture Name', value: 'manufName' },
        { text: 'Vessel Class', value: 'vesClsDesc' },
        { text: 'Vessel Construction', value: 'vesConstnDesc' },
        { text: 'Engine Make', value: 'vesEngMakeDesc' },
        { text: 'Engine Model', value: 'vesEngModDesc' },
        { text: 'Vessel Flag', value: 'vesFlagDesc' },
        { text: 'Vessel Type', value: 'vesTypeDesc' }
      ],
      selectedColumns: ['vesNo', 'vesName', 'vesDesc', 'vesClsDesc', 'vesFlagDesc', 'yrBuilt'],
      totalItems: 0,
      filters: {
        vesNo: null,
        vesName: null,
        vesDesc: null,
        vesOwn: null,
        vesAgt: null,
        yrBuilt: null,
        grt: null,
        nrt: null,
        dwt: null,
        imoRefNo: null,
        licenceNo: null,
        vesEngNo: null,
        mds: null,
        length: null,
        breath: null,
        depth: null,
        hp: null,
        totCrew: null,
        manufName: null,
        vesClsDesc: null,
        vesConstnDesc: null,
        vesEngMakeDesc: null,
        vesEngModDesc: null,
        vesFlagDesc: null,
        vesTypeDesc: null
      },
      filtersLabel: {
        vesNo: 'Vessel No',
        vesName: 'Vessel Name',
        vesDesc: 'Vessel Description',
        vesOwn: 'Vessel Owner',
        vesAgt: 'Vessel Agent',
        yrBuilt: 'Year Built',
        grt: 'Gross Register Tonnage',
        nrt: 'Nett Register Tonnage',
        dwt: 'Dead Weight Tonnage',
        imoRefNo: 'IMO Reference No',
        licenceNo: 'Licence No',
        vesEngNo: 'Vessel Engine No',
        mds: 'Min. Discernable Signal',
        length: 'Length',
        breath: 'Breath',
        depth: 'Depth',
        hp: 'Horse Power',
        totCrew: 'Total Crew',
        manufName: 'Manufacture Name',
        vesClsDesc: 'Vessel Class',
        vesConstnDesc: 'Vessel Construction',
        vesEngMakeDesc: 'Engine Make',
        vesEngModDesc: 'Engine Model',
        vesFlagDesc: 'Vessel Flag',
        vesTypeDesc: 'Vessel Type'
      },
      vesselForm: {
        vesNo: undefined,
        vesName: undefined,
        vesDesc: undefined,
        vesOwn: undefined,
        vesAgt: undefined,
        yrBuilt: undefined,
        grt: undefined,
        nrt: undefined,
        dwt: undefined,
        imoRefNo: undefined,
        licenceNo: undefined,
        vesEngNo: undefined,
        mds: undefined,
        length: undefined,
        breath: undefined,
        depth: undefined,
        hp: undefined,
        totCrew: undefined,
        manufName: undefined,
        vesClsDesc: undefined,
        vesConstnDesc: undefined,
        vesEngMakeDesc: undefined,
        vesEngModDesc: undefined,
        vesFlagDesc: undefined,
        vesTypeDesc: undefined
      },
      showDetailFilters: undefined,
      loading: false,
      promptRemove: false,
      selectedVessel: undefined,
      deleteVessel: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    vesClsList() {
      return this.$store.state.vessel.classList
    },
    vesConstnList() {
      return this.$store.state.vessel.constnList
    },
    vesEngMakeList() {
      return this.$store.state.vessel.engMakeList
    },
    vesEngModList() {
      return this.$store.state.vessel.engModList
    },
    vesFlagList() {
      return this.$store.state.vessel.flagList
    },
    vesTypeList() {
      return this.$store.state.vessel.typeList
    },
    vesselList() {
      return this.$store.state.vessel.vesselList
    },
    vessel() {
      return this.$store.state.vessel.menu
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData(options) {
      const apiUrl = this.vessel.getVslDets
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: rowsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((Vessel) => {
                const convertVessel = {
                  vesNo: Vessel.vesNo,
                  vesName: Vessel.vesName,
                  vesDesc: Vessel.vesDesc,
                  vesOwn: Vessel.vesOwn,
                  vesAgt: Vessel.vesAgt,
                  yrBuilt: Vessel.yrBuilt,
                  grt: Vessel.grt,
                  nrt: Vessel.nrt,
                  dwt: Vessel.dwt,
                  imoRefNo: Vessel.imoRefNo,
                  licenceNo: Vessel.licenceNo,
                  vesEngNo: Vessel.vesEngNo,
                  mds: Vessel.mds,
                  length: Vessel.length,
                  breath: Vessel.breath,
                  depth: Vessel.depth,
                  hp: Vessel.hp,
                  totCrew: Vessel.totCrew,
                  manufName: Vessel.manufName,
                  vesCls: Vessel.vesCls,
                  vesClsDesc: Vessel.vesClsDesc,
                  vesConstn: Vessel.vesConstn,
                  vesConstnDesc: Vessel.vesConstnDesc,
                  vesEngMake: Vessel.vesEngMake,
                  vesEngMakeDesc: Vessel.vesEngMakeDesc,
                  vesEngMod: Vessel.vesEngMod,
                  vesEngModDesc: Vessel.vesEngModDesc,
                  vesFlag: Vessel.Flag,
                  vesFlagDesc: Vessel.vesFlagDesc,
                  vesType: Vessel.vesType,
                  vesTypeDesc: Vessel.vesTypeDesc
                }
                this.items.push(convertVessel)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClearFilters() {
      this.filters.vesNo = null
      this.filters.vesName = null
      this.filters.vesDesc = null
      this.filters.vesOwn = null
      this.filters.vesAgt = null
      this.filters.yrBuilt = null
      this.filters.grt = null
      this.filters.nrt = null
      this.filters.dwt = null
      this.filters.imoRefNo = null
      this.filters.licenceNo = null
      this.filters.vesEngNo = null
      this.filters.mds = null
      this.filters.length = null
      this.filters.breath = null
      this.filters.depth = null
      this.filters.hp = null
      this.filters.totCrew = null
      this.filters.manufName = null
      this.filters.vesClsDesc = null
      this.filters.vesConstnDesc = null
      this.filters.vesEngMakeDesc = null
      this.filters.vesEngModDesc = null
      this.filters.vesFlagDesc = null
      this.filters.vesTypeDesc = null

      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    doNew() {
      this.$router.push({ name: 'vesselReview', params: { vesNo: 'New' } })
    },
    doReview(data) {
      if (data && data.item && data.item.vesNo) {
        this.$router.push({ name: 'vesselReview', params: { vesNo: data.item.vesNo } })
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedVessel = data
        this.deleteVessel = data.vesNo + ' - ' + data.vesName
      }
    },
    async doRemove() {
      const apiURI = this.vessel.deleteVslDet
      if (apiURI) {
        this.loading = true
        const expand = {
          vesNo: this.selectedVessel.vesNo
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.fetchData(false)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData(true)
  },
  mixins: [
    listVesMixin
  ]
}
</script>

<style lang="scss">
</style>
